// extracted by mini-css-extract-plugin
module.exports = {"splash-background":"splashStartSkydropx_splash-background__1E9Cs","splash-text-h3":"splashStartSkydropx_splash-text-h3__22SMR"};